//
export default [
    {
        text: 'código interno',
        value: 'internal_code',
        width: '15%',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'cantidad',
        value: 'quantity',
        //format: 'number-point',
        align: 'right',
        input: {
            reverse: true,
            type: 'float-field',
        },
        width: '15%',
    },
]
